<template>
  <div class="deleted d-flex flex-column justify-content-center align-items-center">
    <div class="image-container mb-4">
      <img src="../../public/img/Consagradas_logo_login.png" class="img-fluid" />
    </div>
    <div class="card p-4 text-center">
      <div v-if="step == 1">
      <p>Si deseas eliminar tu cuenta indica tu correo electrónico</p>
      <label class="text-left w-100">Correo electrónico</label>
      <input type="email" v-model="form_save.email" class="form-control mb-3" placeholder="Ingresa tu correo" />
      <button @click="sendCodeEmail" class="btn btn-primary">Enviar</button>
    </div>
    <div v-if="step == 2">
        <p>Indica el código que llegó a tu correo</p>
        <div class="row">
                          <div class="col-md-12">
                            
                            <label>Correo indicado</label>
                            <input
                              class="form-control"
                              type="text"
                              v-model="form_save.email"
                              disabled
                            />
  
                            <label>Código recibido</label>
                            <input
                              class="form-control"
                              type="text"
                              v-model="form_save.verif_code"
                            />
                          </div>
                        
                        </div>
                        <br>
                        <div class="row">
                          <div class="col-md-6">
                            <div class="text-center">
                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="step -= 1"
                                ><span>Atrás</span></button
                              >
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="text-center">
                              <button
                               type="button"
                                class="btn btn-primary"
                                @click="sendToNextStep"
                                ><span>Siguiente</span></button
                              >
                            </div>
                          </div>
                        </div>
        </div>
        <div v-if="step == 3">
          <p style="color: red; font-weight: 800; margin-bottom: 1px;">¡Atención!</p>
          <p style="margin-bottom: 1px;">Eliminación de tu cuenta</p>
          <p style="margin-bottom: 1px;">Queremos informarte que si decides eliminar tu cuenta, perderás todo acceso a ella de forma permanente. Esto significa que:</p>
          <ul class="text-left">
          <li style="  font-family: Poppins-Medium;
" >No podrás volver a iniciar sesión.</li>
          <li style="  font-family: Poppins-Medium;
" >Tendrás que crear una cuenta nueva si deseas utilizar la aplicación en el futuro.</li>
          <li style="  font-family: Poppins-Medium;
" >Se borrará todo tu historial de consultas y cualquier otro dato almacenado en tu cuenta.</li>
        </ul>
        <div class="row">
                          <div class="col-md-6">
                            <div class="text-center">
                              <button
                                type="button"
                                class="btn btn-danger"
                                @click="step -= 1"
                                ><span>Atrás</span></button
                              >
                            </div>
                          </div>
                          <div class="col-md-6">
                            <div class="text-center">
                              <button
                               type="button"
                                class="btn btn-primary"
                                @click="sendVerificationCode"
                                ><span>Borrar cuenta</span></button
                              >
                            </div>
                          </div>
                        </div>
          </div>
    </div>
  </div>
</template>

<script>
  import { mapActions } from "vuex";
  import EmailValidator from 'email-validator';
  export default {
    data() {
      return {
        step: 1,
        form_save: {
          email: "",
          verif_code: "",
        },
      };
    },
    methods: {
      ...mapActions(["login", "getData", "createData","updateDataClean"]),
      sendCodeEmail() {
        let validate = EmailValidator.validate(this.form_save.email);
        if (!validate) {
          Swal.fire({
            title: "Email inválido",
            text: "Debes escribir un email válido para poder continuar",
            icon: "warning",
            confirmButtonColor: "#20C29D",
          });
        } else {
          let data_to_send={
              email: this.form_save.email
          }
          let form = {
                url: "public/delete_account/send",
                data: data_to_send
              };
  
            this.createData(form)
              .then((response) => {
                if (response.code === 200) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Correo enviado",
                    text: "Hemos enviado un código a tu correo para que puedas eliminar tu cuenta",
                    icon: "success",
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
                    confirmButtonColor: "#AA1E2E",
  
                  }).then((result) => {
                    console.log(result)
                    this.step +=1;
                  });

                }
                if (response.code === 408) {
                  this.deleting = false;
          
                }
                if (response.code === 404) {
                  this.deleting = false;
                
                  Swal.fire({
                    title: "Correo no encontrado",
                    text: "Fallo al enviar el correo, verifica que el correo sea correcto",
                    icon: "warning",
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
  
                  }).then((result) => {
                    console.log(result)
                  });
                }
                if (response.code === 409) {
                  this.deleting = false;
                 
                }
              })
              .catch((error) => {
                console.log(error);
                this.deleting = false;
                alert("Ocurrió un error, intente más tarde");
              });
        }

      },

      sendToNextStep() {
        if (this.form_save.verif_code == "") {
          Swal.fire({
            title: "Código inválido",
            text: "Debes indicar el código que te enviamos a tu correo",
            icon: "warning",
            confirmButtonColor: "#AA1E2E",
          });
          return;
        }
        // if (this.form_save.email == "") {
        //   Swal.fire({
        //     title: "Correo inválido",
        //     text: "Debes indicar el correo que usaste para registrarte",
        //     icon: "warning",
        //     confirmButtonColor: "#20C29D",
        //   });
        //   return;
        // }
        this.step += 1;
      },

      sendVerificationCode() {

        let data_to_send={
            email: this.form_save.email,
            code: this.form_save.verif_code
        }
        let form = {
              url: "public/delete_account/verify",
              data: data_to_send
            };
  
            this.createData(form)
              .then((response) => {
                if (response.code === 200) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Código validado",
                    text: "Tu cuenta ha sido eliminada",
                    icon: "success",
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
  
                  }).then((result) => {
                    console.log(result)
                    window.location.href = "https://consagradasrc.org/";
                  });
  
  
  
                }
                if (response.code === 401) {
                  this.deleting = false;
                  Swal.fire({
                    title: "Código inválido",
                    text: "El código que indicaste es inválido o esta vencido",
                    icon: "warning",
                    showConfirmButton: true,
                    showLoaderOnConfirm: true,
  
                  })
  
                  //this.AllElements();
                }
              })
              .catch((error) => {
                console.log(error);
                this.deleting = false;
                alert("Ocurrió un error, intente más tarde");
                this.AllElements();
              });
      },
    },
  };

</script>
<style>
.deleted {
  height: 100vh;
  width: 100vw;
  background-color: #AA1E2E ;
}

.card {
  max-width: 400px;
  width: 100%;
}

.image-container {
  max-width: 300px;
  width: 100%;
}
.btn-primary {
  background-color: transparent;
  border: 2px solid #AA1E2E;
  color: #AA1E2E;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}
.btn-primary:hover {
  background-color: #AA1E2E !important;
  border-color: #AA1E2E !important;
  color: white;
}
.form-control:focus {
  border-color: #AA1E2E;
  box-shadow: 0 0 0 0.2rem rgba(170, 30, 46, 0.25);
}

</style>
